export const getPlatformFeeInitialValues = (showData) => ({
  entity_type: showData?.data?.entity_type || "",
  amount_type: showData?.data?.amount_type || "",
  amount: showData?.data?.amount || 0,
  currency_code: showData?.data?.currency_code || "",
});
